import React, {Component} from "react";
import {connect} from "react-redux"
import {
    requestDoctorsPage,
    getAuthFollowedDoctors,
    clearDoctorList,
    goToDoctorProfileFromBooking,
    clearGoToDoctorProfileFromBooking,
    clearSearchData
} from "../../store/actions/doctorActions";
import {withTranslate} from "react-redux-multilingual";
import DoctorCard from "./DoctorCard";
import Search from "./../search/Search";
import {withRouter} from "react-router-dom"
import NoData from "../NoData";
import {setDoctorsSkeleton} from "../../skeleton";
import {withLastLocation} from 'react-router-last-location';
import Maintenance from "../Maintenance";
import {clearError500} from "../../store/actions/globalActions";


class DoctorsPage extends Component {
    state = {
        scroll: true,
    };
    handleSearchData = async (page = 1) => {

            if ((this.props.lastLocation && this.props.lastLocation.pathname.includes("RK_ACC")) === false &&
                document.referrer.includes("RK_ACC") === false && this.props.searchFromFooter === false) {
              await this.props.clearSearchData();
            } else {
                localStorage.removeItem("searchData")
            }

        const keyword = this.props.currentSearchData && this.props.currentSearchData.keyword;
        const city = this.props.currentSearchData && this.props.currentSearchData && this.props.currentSearchData.city ? this.props.currentSearchData.city.id : null;
        const province = this.props.currentSearchData && this.props.currentSearchData && this.props.currentSearchData.province ? this.props.currentSearchData.province.id : null;
        const specialty = this.props.currentSearchData && this.props.currentSearchData.specialty ? this.props.currentSearchData.specialty.slug : "";
        if(this.props.isFavourite){
            this.props.getAuthFollowedDoctors(page, specialty, keyword, specialty, null, city, province);
        }else{
            this.props.requestDoctorsPage(page, specialty, keyword, specialty, null, city, province);
        }
    };

    componentDidMount() {
        this.props.clearError500();
        // let searchDataCached = localStorage.getItem("searchData") ? JSON.parse(localStorage.getItem("searchData")) : null;
        this.props.clearDoctorList();
        this.handleSearchData();
        this.props.clearGoToDoctorProfileFromBooking();
    };

    fetchPage = (page, e) => {
        e.preventDefault();
        this.handleSearchData(page);
    };
    handelBookingFromMobile = () => {
        this.props.goToDoctorProfileFromBooking();
    };

    render() {
        if (this.props.error500) {
            return (
                <Maintenance/>
            )
        }
        const doctorsList = this.props.doctors && this.props.doctors.length > 0 ? this.props.doctors.map((doctor, index) => {
            return (
                <div className="ftco-animate col-md-6 col-xs-12" key={doctor.id}>
                    <DoctorCard language={this.props.language}  doctor={doctor} handelBookingFromMobile={() => this.handelBookingFromMobile()}/>
                </div>
            )
        }) : <NoData image="no-doctors"/>;

        return (
            <section id="doctors-list-all" className="ftco-section doctors-list-all doctors-list">

                <div className="container">
                    {
                        this.props.isFavourite ? null
                            :
                            <Search mobileMenuIsShown={this.props.mobileMenuIsShown}/>

                    }

                    <div className="row" hidden={this.props.doctorsListIsLoading === true}>

                        {doctorsList}

                        <div className="col-md-12">
                            <div className="loading-more cursor-pointer"
                                 hidden={this.props.currentPage === this.props.lastPage || this.props.fetchingPage === true}>
                                <div className="text-center">
                                    <a href="/" style={{pointerEvents: 'false'}} className="btn shadow-4d"
                                       onClick={(e) => this.fetchPage(this.props.currentPage + 1, e)}>{this.props.translate("fetch_more")}</a>
                                </div>
                            </div>

                            <div className="loading-more" hidden={this.props.fetchingPage === false}>
                                <div className="text-center">
                                    <img style={{width: '100px'}} src="/images/loading.svg" alt="loading"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row" hidden={this.props.doctorsListIsLoading === false}>
                        {setDoctorsSkeleton(9)}
                    </div>
                </div>
            </section>
        )
    }
}


const mapStateToProps = (state) => {

    return {
        doctors: state.doctor.doctors,
        currentPage: state.doctor.currentPage,
        lastPage: state.doctor.lastPage,
        total: state.doctor.total,
        fetchingPage: state.doctor.fetchingPage,
        doctorsListIsLoading: state.doctor.doctorsListIsLoading,
        currentSearchData: state.doctor.currentSearchData,
        goToDoctorProfileFromBooking: state.doctor.goToDoctorProfileFromBooking,
        searchFromFooter: state.doctor.searchFromFooter,
        error500: state.global.error500,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        requestDoctorsPage: (page, specialtyString, keyword, slug, sort, city_id, province_id) => dispatch(requestDoctorsPage(page, specialtyString, keyword, slug, sort, city_id, province_id)),
        getAuthFollowedDoctors: (page, specialtyString, keyword, slug, sort, city_id, province_id) => dispatch(getAuthFollowedDoctors(page, specialtyString, keyword, slug, sort, city_id, province_id)),
        clearDoctorList: () => dispatch(clearDoctorList()),
        goToDoctorProfileFromBooking: () => dispatch(goToDoctorProfileFromBooking()),
        clearGoToDoctorProfileFromBooking: () => dispatch(clearGoToDoctorProfileFromBooking()),
        clearSearchData: () => dispatch(clearSearchData()),
        clearError500: () => dispatch(clearError500())
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(withRouter(withLastLocation(DoctorsPage))));

